export default __webpack_public_path__ + "static/media/workout.bda325c6.svg";